"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _optionProcessor = require("../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor");

var _optionProcessor2 = _interopRequireDefault(_optionProcessor);

var _core = require("@mpxjs/core");

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/components/common/privacy-policy.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

var wxsModules = {}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

global.currentSrcMode = "wx";

(0, _core.createComponent)({
  name: 'PrivacyPolicy',
  properties: {},
  methods: {},
  data: function data() {
    try {
        return {};
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('data@@../../../../src/components/common/privacy-policy.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
});
var currentOption = global.currentOption;
exports.default = (0, _optionProcessor2.default)(currentOption, "component", "", "privacy-policy31203faf", {}, // @ts-ignore
{}, // @ts-ignore
{}, undefined, {}, undefined, (0, _optionProcessor.getWxsMixin)(wxsModules));